import React, { useState } from "react";

const LS = "r2w_tour_v1";

const seen = () => { try { return JSON.parse(localStorage.getItem(LS) || "[]"); } catch { return []; } };
export const dismissTip = (id) => localStorage.setItem(LS, JSON.stringify([...new Set([...seen(), id])]));
export const resetTour = () => localStorage.removeItem(LS);
export const tourSeen = (id) => seen().includes(id);

// Floating welcome-tour bubble (dashboard first-run tour).
export function TipBubble({ emoji, title, children, step, total, onNext, onSkip, nextLabel }) {
  return (
    <div className="fixed inset-x-4 bottom-24 md:bottom-8 z-[60] mx-auto max-w-md animate-slide-in" data-testid="tour-bubble">
      <div className="overflow-hidden rounded-3xl border-2 border-teal-200 bg-white shadow-2xl">
        <div className="h-1.5 bg-gradient-to-r from-teal-500 via-emerald-400 to-lime-400" />
        <div className="p-4">
          <div className="flex items-start gap-3">
            <span className="text-3xl leading-none">{emoji}</span>
            <div className="flex-1">
              <p className="font-heading font-bold text-teal-900">{title}</p>
              <p className="mt-1 text-sm text-slate-600">{children}</p>
            </div>
          </div>
          <div className="mt-3 flex items-center justify-between">
            <button data-testid="tour-skip" onClick={onSkip} className="rounded-lg px-3 py-1.5 text-xs font-medium text-slate-400 hover:text-slate-600">Skip the tour</button>
            <div className="flex items-center gap-2">
              <span className="text-xs text-slate-400 font-num">{step}/{total}</span>
              <button data-testid="tour-next" onClick={onNext} className="rounded-xl btn-grad px-4 py-2 text-sm font-bold text-white shadow">{nextLabel || "Next →"}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const STEPS = [
  { emoji: "🗓️", title: "Your week at a glance", body: "This strip shows Sun → Sat. Green means a shift is filed and balanced, amber means it still needs attention. Tap any day to see what happened." },
  { emoji: "➕", title: "File a sheet from the floor", body: "The big ＋ button starts a new entry — one question per screen. A brand-new supervisor can file a balanced sheet in under 3 minutes." },
  { emoji: "🍗", title: "Products have their own colours", body: "Every product family has an emoji and colour so you can recognise them at a glance — on cards, in the wizard and in reports." },
];

export function DashboardTour({ open, onClose }) {
  const [i, setI] = useState(0);
  if (!open) return null;
  const s = STEPS[i];
  const next = () => { if (i < STEPS.length - 1) setI(i + 1); else { dismissTip("dashboard"); onClose(); } };
  const skip = () => { dismissTip("dashboard"); onClose(); };
  return (
    <>
      <div className="fixed inset-0 bg-black/20 z-[55] pointer-events-none" />
      <TipBubble emoji={s.emoji} title={s.title} step={i + 1} total={STEPS.length} onNext={next} onSkip={skip}
        nextLabel={i === STEPS.length - 1 ? "Got it 🎉" : "Next →"}>{s.body}</TipBubble>
    </>
  );
}
